var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-collapse', {
    class: _vm.className,
    attrs: {
      "tag": "ul",
      "visible": _vm.open,
      "id": _vm.idName,
      "accordion": _vm.accordianName
    }
  }, [_vm._l(_vm.visibleItems, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.activeLink(item),
        'menu-dropdown': _vm.isDropdown(item),
        'menu-dropdown-open': _vm.isDropdown(item) && _vm.isExpanded(item, index)
      }
    }, [_vm.isDropdown(item) ? _c('a', {
      staticClass: "iq-waves-effect menu-dropdown-toggle",
      attrs: {
        "href": "#",
        "role": "button",
        "aria-expanded": String(_vm.isExpanded(item, index)),
        "aria-controls": _vm.submenuId(index)
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleDropdown(item, index);
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
          $event.preventDefault();
          return _vm.toggleDropdown(item, index);
        }
      }
    }, [_vm.isSvgIcon(item) ? _c('span', {
      staticClass: "menu-response-icon",
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }) : item.iconClass && !_vm.hideDropdownClassIcon(item) ? _c('i', {
      class: item.icon
    }) : !item.iconClass ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.$t(item.menu)))]), _c('span', {
      staticClass: "menu-dropdown-arrow",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm.hasComponent(item) && item.url ? _c('a', {
      staticClass: "iq-waves-effect",
      class: {
        active: _vm.activeLink(item)
      },
      attrs: {
        "href": item.url
      }
    }, [_vm.isSvgIcon(item) ? _c('span', {
      staticClass: "menu-response-icon",
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }) : item.iconClass ? _c('i', {
      class: item.icon
    }) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t(item.menu)))])]) : [!item.heading && _vm.depth === 0 ? _c('i', {
      staticClass: "ri-subtract-line"
    }) : _vm._e(), !item.heading && _vm.depth === 0 ? _c('span', [_vm._v(_vm._s(_vm.$t(item.menu)))]) : _vm._e(), (item.heading || _vm.depth > 0) && item.className != 'true' && !item.component ? _c('router-link', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: item.menu,
        expression: "item.menu"
      }],
      staticClass: "iq-waves-effect",
      class: {
        active: _vm.activeLink(item)
      },
      attrs: {
        "to": {
          name: item.props,
          query: {
            menuId: item.menuId
          }
        }
      }
    }, [_vm.isSvgIcon(item) ? _c('span', {
      staticClass: "menu-response-icon",
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }) : item.iconClass ? _c('i', {
      class: item.icon
    }) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t(item.menu)))])]) : _vm._e()], _vm.isDropdown(item) ? _c('List', {
      attrs: {
        "items": _vm.childItems(item),
        "class-name": "iq-submenu menu-nested-list",
        "open": _vm.isExpanded(item, index),
        "id-name": _vm.submenuId(index),
        "accordian-name": null,
        "depth": _vm.depth + 1,
        "horizontal": _vm.horizontal
      }
    }) : _vm._e()], 2);
  }), _vm.depth === 0 ? _c('li', {
    staticClass: "d-flex mt-5",
    staticStyle: {
      "cursor": "pointer",
      "overflow": "auto",
      "top": "180px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearCache
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh mr-2"
  }), _c('span', [_vm._v("Clear Cache")])])]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }